import React from 'react';
import * as PropTypes from 'prop-types';
import Select from '../../form/components/Select';
import { FormControl } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { useRef, useEffect } from 'react';
  
const MailFolderSelect = ({ name, label, disabled, onChange, ...other }) => {
    const { values, setFieldValue, initialValues  } = useFormikContext(); 
    const onChangeRef = useRef(onChange);

    const folder_options = [
        { value: 'mail_inbox', label: 'Mail-Eingang' },
        { value: 'mail_drafts', label: 'Mail-Entwürfe' },
    ];

    const onChangeHandler = (e, value) => {
        onChange(value);
    }

    useEffect(() => {
        if (onChangeRef.current) {
            onChangeRef.current(values, initialValues, setFieldValue);
          }
    }, [values, initialValues, setFieldValue]);

    return (
        <FormControl 
            fullWidth>
            <Select
                name={name}
                options={folder_options}
                label={label}
                disabled={disabled}
                fullWidth
                onChange={onChangeHandler}
                {...other}
            />
        </FormControl>
    );
};

MailFolderSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

MailFolderSelect.defaultProps = {
    label: null,
    disabled: false,
    onChange: () => {},
};

export default MailFolderSelect;
